import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Thomas Hunsaker
 * id 7F6DF58A-C9A3-4CE7-9664-28C04218C628
 * name medical-bag
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/medical-bag.svg
 * tags
 * - Medical / Hospital 
 */
export const MedicalBagIcon = createSvgIcon(<><path d="M10,3L8,5V7H5C3.85,7 3.12,8 3,9L2,19C1.88,20 2.54,21 4,21H20C21.46,21 22.12,20 22,19L21,9C20.88,8 20.06,7 19,7H16V5L14,3H10M10,5H14V7H10V5M11,10H13V13H16V15H13V18H11V15H8V13H11V10Z" /></>, 'MedicalBagIcon');
export default MedicalBagIcon